import {USER_LOGGED_OUT} from "../../../../screens/user/constants/actionTypes";
import {
  TW_CONNECTED,
  TW_ROOM_ADD,
  TW_ROOM_REMOVE,
  TW_TOKEN
} from "../constants/actionTypes";

const defaultState = {"isConnected": false};

export const twilioReducer = (state = defaultState, action) => {
  switch (action.type) {
    case USER_LOGGED_OUT:
      return defaultState;
    case TW_TOKEN:
      return {
        ...state,
        token: action.token
      };
    case TW_ROOM_ADD:
      return {
        ...state,
        video: {room: action.room}
      };
    case TW_CONNECTED:
      return {
        ...state,
        isConnected: action.payload
      };
    case TW_ROOM_REMOVE:
      return {
        ...state,
        video: {room: {}}
      };
    default:
      return state;
  }
};
